import {onActivated,onDeactivated,ref,} from 'vue'
export function useComponentIsActive () {
    let componentIsActive = ref(true)
    onActivated(()=>{
        componentIsActive.value = true
    })
    onDeactivated(()=>{
        componentIsActive.value = false
    })

    return {
        componentIsActive,
    }
}